(() => {
  if (!customElements.get("echo-video")) {
    class EchoVideo extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.videoWrapper = this.querySelector(".echo-video_wrapper");
        this.button = this.querySelector("button");
        this.desktopVideo = this.querySelector(".desktop-video");
        this.mobileVideo = this.querySelector(".mobile-video");

        // Choose one video to control — you can customize this logic
        this.video = window.innerWidth < 768 ? this.mobileVideo : this.desktopVideo;

        if (!this.video || !this.button) return;

        this.button.addEventListener("click", () => this.togglePlay());
        this.video.addEventListener("pause", () => this.updateButton());
        this.video.addEventListener("play", () => this.updateButton());

        // Initialize state
        this.updateButton();
      }

      togglePlay() {
        if (this.video.paused) {
          this.video.play();
        } else {
          this.video.pause();
        }
      }

      updateButton() {
        const isPaused = this.video.paused;

        this.button.querySelector(".iconify-play").style.display = isPaused ? "block" : "none";
        this.button.querySelector(".iconify-pause").style.display = isPaused ? "none" : "block";

        this.videoWrapper.classList.toggle("playing", !isPaused);
        this.videoWrapper.classList.toggle("paused", isPaused);
      }
    }

    customElements.define("echo-video", EchoVideo);
  }
})();
